module.exports = __webpack_public_path__ + "static/media/badge.e1e9fed3.png";